import { Modal } from 'antd';
import { useState } from 'react';
import type { RcFile, UploadFile } from 'antd/es/upload/interface';

export const getBase64Representation = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    // After we call the function "readAsDataURL", the reader.result will be a string.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    reader.addEventListener('load', () => resolve(reader.result as string));
    reader.addEventListener('error', (error) => reject(error));
  });

export const useFilePreview = (): {
  readonly handlePreview: (file: UploadFile) => Promise<void>;
  readonly previewContent: JSX.Element;
} => {
  const [previewVisibility, setPreviewVisibility] = useState(false);
  const [previewImage, setPreviewImage] = useState<string>();
  const [previewTitle, setPreviewTitle] = useState('');

  const handlePreview = async (file: UploadFile) => {
    if (file.preview !== undefined) {
      setPreviewImage(file.preview);
    } else if (file.url !== undefined) {
      setPreviewImage(file.url);
    } else if (file.originFileObj !== undefined) {
      setPreviewImage(await getBase64Representation(file.originFileObj));
    }
    setPreviewTitle(file.name);
    setPreviewVisibility(true);
  };

  const hidePreview = () => {
    setPreviewVisibility(false);
  };

  const previewContent = (
    <Modal
      open={previewVisibility}
      title={previewTitle}
      footer={null}
      onCancel={hidePreview}
    >
      <img alt={previewTitle} style={{ width: '100%' }} src={previewImage} />
    </Modal>
  );

  return { handlePreview, previewContent };
};
